import graphQLWrapper from 'shared/graphql/withApollo';
import { Homepage } from 'homepage/pages/Homepage';
import { GetServerSidePropsContext } from 'next';

export default graphQLWrapper(Homepage);
import { initializeApollo } from 'shared/graphql/apolloClient';
import GET_HERO_INFO from 'homepage/queries/heroContent';
import PROPERTY_NEWS_QUERY from 'homepage/queries/propertyNews.graphql';
import {
    ArticlesForHomepageQuery,
    ArticlesForHomepageQueryVariables
} from 'homepage/queries/propertyNews.generated';

export async function getServerSideProps({ req }: GetServerSidePropsContext) {
    const apolloClient = initializeApollo(null, req.headers);

    try {
        const [heroInfo, propertyNews] = await Promise.all([
            await apolloClient?.query({
                query: GET_HERO_INFO,
                context: { clientName: 'contentful' }
            }),
            await apolloClient?.query<
                ArticlesForHomepageQuery,
                ArticlesForHomepageQueryVariables
            >({
                query: PROPERTY_NEWS_QUERY
            })
        ]);

        const { items } = heroInfo?.data?.homepageCollection || {};
        const homepageData = items[0] || {};
        const { brandHeadline, h1TitleTag, heroImage } = homepageData;

        return {
            props: {
                brandHeadline,
                h1TitleTag,
                heroImage,
                propertyNewsArticles: propertyNews?.data?.articles
            }
        };
    } catch (error) {
        // TODO: handle logging
        console.log('Homepage Contentful error: ', error);
        return {
            props: {}
        };
    }
}
